import { render, staticRenderFns } from "./PlatformPage.vue?vue&type=template&id=c2efd47e&scoped=true"
import script from "./PlatformPage.vue?vue&type=script&lang=js"
export * from "./PlatformPage.vue?vue&type=script&lang=js"
import style0 from "./PlatformPage.vue?vue&type=style&index=0&id=c2efd47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2efd47e",
  null
  
)

export default component.exports